export default "__VITE_ASSET__SLB_ccUd__"